import { render, staticRenderFns } from "./Arsa.vue?vue&type=template&id=217208bc&scoped=true&"
import script from "./Arsa.vue?vue&type=script&lang=js&"
export * from "./Arsa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217208bc",
  null
  
)

export default component.exports